/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.courserequired[_ngcontent-%COMP%], div.warning[_ngcontent-%COMP%]{color:red}.warningblock[_ngcontent-%COMP%]{margin-top:15px}.fasttrackblock[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}.removedcheckbox[_ngcontent-%COMP%]{margin-top:15px}[_nghost-%COMP%]     .mat-checkbox-layout{white-space:normal!important}.actionbar[_ngcontent-%COMP%]{margin-bottom:15px}.extra-options[_ngcontent-%COMP%]{opacity:.75;font-size:.75em}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/courseselectionpanel/courseselectionpanel.component.css.shim.ngstyle.js.pre-build-optimizer.js